import moment from "moment";
import { mapGetters } from "vuex";
import ApiService from "../../services/api";


export default {
	props: {
		pageTitle: String,
		showDateTime: {
			type: Boolean,
			default: true
		}
	},
	data: function() {
		return {
			displayDateTime: true,
			currentDate: "",
			currentTime: "",
			mailObjectTypes: [
				"", "ALTRO", "IMPORTAZIONI", "MALFUNZIONAMENTO", "NUOVA RICHIESTA"
			],

			showSupportForm: false,
			senderName: "",
			senderNameError: false,
			senderMail: "",
			senderMailError: false,
			mailObjectTypesSelected: null,
			mailObjectTypesSelectedError: false,
			descriptionMail: "",
			descriptionMailTwo: "",
			descriptionMailError: false,
		};
	},
	created() {
		this.displayDateTime = this.$props.showDateTime;

		if (this.displayDateTime) {
			this.clock();
		}

		this.senderName = this.currentUser.name;
	},
	methods: {
		sendMailAction() {
			var data = {};
			this.senderNameError = false;
			this.senderMailError = false;
			this.descriptionMailError = false;
			//this.mailObjectTypesSelectedError = false;

			var anyError = false;

			if (!this.senderName) {
				this.senderNameError = true;
				anyError = true;
			}
			if (!this.senderMail) {
				this.senderMailError = true;
				anyError = true;
			}
			// if (!this.mailObjectTypesSelected) {
			// 	this.mailObjectTypesSelectedError = true;
			// 	anyError = true;
			// }
			if (!this.descriptionMail && !this.descriptionMailTwo) {
				this.descriptionMailError = true;
				anyError = true;
			}

			if (anyError) return;

			data["from"] = this.senderName;
			data["email"] = this.senderMail;
			//data["subject"] = this.mailObjectTypesSelected;
			data["body"] = `${this.descriptionMail}\r\n${this.descriptionMailTwo}`;

			var self = this;
			ApiService.supportSendMail(data).then(() => {
				self.closeSupportMailModal();
			});

			
		},
		undoMailAction() {
			this.closeSupportMailModal();
		},
		closeSupportMailModal() {
			this.senderName=  this.currentUser.name;
			this.senderMail=  "";
			//this.mailObjectTypesSelected = null;
			this.descriptionMail = "";
			this.descriptionMailTwo = "";

			this.senderNameError = false;
			this.senderMailError = false;
			this.descriptionMailError = false;
			//this.mailObjectTypesSelectedError = false;
			
			this.showSupportForm = false;
		},
		openFormEmailSupport() {
			this.senderName = this.currentUser.name;
			this.showSupportForm = true;
		},
		logout() {
			this.$store.dispatch("logout").then(res => {
				this.$router.push({
					name: "login",
					params: {fromLogout: true }
				});
			});
		},
		clock: function() {
			var self = this;

			moment.locale("it");

			setInterval(() => {
				var tempDate = moment();
				self.currentDate = tempDate.format("dddd DD/MM/YYYY");
				self.currentTime = "ORE " + tempDate.format("LTS");
			}, 1000);
		}
	},
	computed: {
		...mapGetters(["currentUser"]),
		hasActionBarSlot() {
			return this.$slots.actionbar;
		},
		userName: function() {
			return this.currentUser.name;
		},
	}
};
